<script>
const user_model_name = "user_model"

//读取用户数据
function getUserinfo () {
  const info = JSON.parse(window.sessionStorage.getItem('user_model'))
  console.log(info);
  return info
}
//更新用户数据
function setUserinfo (user_model) {
  //axios.get("app/mutual/attribute/?appid=202108&type_id=4001&openid=zswd9999").then(res => {
  //   const user_model = res.data.data.data[0].models[0];
  // console.log(user_model);
  const rowObj = JSON.stringify(user_model)
  window.sessionStorage.setItem('user_model', rowObj);
  //this.$router.push('/home')
  //})
}

export default {
  user_model_name,
  setUserinfo,
  getUserinfo

}
</script>



// WEBPACK FOOTER //
// src/components/tool/user_model.vue